import { AxiosService } from './axios.service'
import { SearchService } from './search.service'

/**
 * Defines the API methods for the store products
 */
export class StoreProductService extends SearchService {
	static baseURL = 'produto'

	/**
	 * List the store products
	 * @return {Promise<any[]>} List products
	 */
	static list(params) {
		return AxiosService.get(`${StoreProductService.baseURL}/listar`, {
			params
		}).then(({ data }) => data)
	}

	/**
	 * Get the store product
	 * @return {Promise<any>} The product
	 */
	static get(productId) {
		return AxiosService.get(
			`${StoreProductService.baseURL}/${productId}`
		).then(({ data }) => data)
	}

	/**
	 * Get the store product details
	 * @return {Promise<any>} The product details
	 */
	static getDetails(productId) {
		return AxiosService.get(
			`${StoreProductService.baseURL}/${productId}/detalhes`
		).then(({ data }) => data)
	}

	/**
	 * Redeem the store product
	 * @return {Promise<any>}
	 */
	static redeem(params) {
		return AxiosService.post(
			`${StoreProductService.baseURL}/resgatar`,
			params
		).then(({ data }) => data)
	}

	/**
	 * List latest products
	 * @return {Promise<any[]>}
	 */
	static listLatest(params) {
		return AxiosService.get(
			`${StoreProductService.baseURL}/buscar-recentes`,
			{
				params
			}
		).then(({ data }) => ({
			items: data.data
		}))
	}

	/**
	 * Searches the products
	 * @return {Promise<any[]>} List of products
	 */
	static search(params) {
		return AxiosService.get(`${StoreProductService.baseURL}/buscar`, {
			params
		}).then(({ data }) => ({
			rows: data.data,
			totalRows: super.getTotalRows(data.data)
		}))
	}

	/**
	 * Spotlight the product
	 * @param {number} productId The productId to be spotlighted
	 */
	static spotlight(productId) {
		return AxiosService.post(
			`${StoreProductService.baseURL}/${productId}/destacar`
		).then(({ data }) => data)
	}

	/**
	 * Remove the product spotlight
	 * @param {number} productId The productId to remove the spotlight
	 */
	static removeSpotlight(productId) {
		return AxiosService.post(
			`${StoreProductService.baseURL}/${productId}/remover-destaque`
		).then(({ data }) => data)
	}

	/**
	 * Activate a product
	 * @param {number} productId The productId to be activate
	 */
	static activate(productId) {
		return AxiosService.post(
			`${StoreProductService.baseURL}/${productId}/ativar`
		).then(({ data }) => data)
	}

	/**
	 * Deactivate a product
	 * @param {number} productId The productId to be deactivate
	 */
	static deactivate(productId) {
		return AxiosService.post(
			`${StoreProductService.baseURL}/${productId}/inativar`
		).then(({ data }) => data)
	}

	/**
	 * Create a product
	 * @param {any} params The data to create the product
	 */
	static create(params) {
		return AxiosService.post(
			`${StoreProductService.baseURL}/criar`,
			params
		).then(({ data }) => data)
	}

	/**
	 * Edit a product
	 * @param {any} params The data to edit the product
	 */
	static edit(params) {
		return AxiosService.post(
			`${StoreProductService.baseURL}/editar`,
			params
		).then(({ data }) => data)
	}
}
